import React from 'react'
import SarasProgress from '../../notifications/progress/SarasProgress';

const FormProgress = (props) => {
    const { formObject, action, rowKey, headerKey, progressType, over100IsDelay, 
        progressScopeClass, progressClass, delayClass, labelClass, ...restProps } = props;

    const viewData = formObject.getFormData(rowKey, headerKey, action.paramName);
    const hide = formObject.getValueFromKey(viewData, "dataList.isHid", "0");

    
    if(viewData && viewData.val > 0 && hide === "0"){
        const isDelay = viewData.val > 100 && over100IsDelay ? true : false;

        return (
            <SarasProgress value={viewData.val} progressType={progressType || "circle"} 
                progressScopeClass={progressScopeClass}
                progressClass={isDelay? delayClass : progressClass} 
                labelClass={labelClass} {...restProps} />
        )
    }

    return (null);
}

export default FormProgress